import { createFileRoute } from "@tanstack/react-router";
import { FacturationPanel } from "@/components/qorum/FacturationPanel";
import { socialMeta } from "@/lib/seo-meta";

export const Route = createFileRoute("/compte/facturation")({
  head: () => ({
    meta: [{ title: "Facturation — Hōjin" }, { name: "robots", content: "noindex, nofollow" },
      ...socialMeta({
        title: "Facturation — Hōjin",
        description: "Facturation — Hōjin",
        url: "https://hojin.ai/compte/facturation",
        image: "secretaire",
        card: "summary_large_image",
      }),
    ],
    links: [{ rel: "canonical", href: "https://hojin.ai/compte/facturation" }],
  }),
  component: () => <FacturationPanel />,
});
